import {
  Box,
  Button,
  Modal,
  ModalCloseButton,
  ModalContent,
  Theme,
} from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import React from "react";

export default React.forwardRef(ShowMoreModalControlled);

// This is a controlled version of the ShowMoreModal component.
// Use this when the modal state is controlled by the parent component.
function ShowMoreModalControlled(
  {
    isModalOpen,
    buttonLabel,
    onButtonClicked,
    onCloseModal,
    children,
  }: {
    isModalOpen: boolean;
    buttonLabel: string;
    onButtonClicked: () => void;
    onCloseModal: () => void;
    children: React.ReactNode;
  },
  ref: React.Ref<any>
) {
  const { t } = useTranslation(
    "ui-components-website\\ClassDetailsPage\\ShowMoreModal"
  );

  return (
    <>
      <Button
        ref={ref}
        onClick={onButtonClicked}
        color="neutral"
        sx={(theme: Theme) => ({
          color: "black",
          marginTop: 16,
          width: "fit-content",
          [theme.breakpoints.down("md")]: {
            width: "100%",
          },
        })}
      >
        {buttonLabel}
      </Button>
      <Modal open={isModalOpen} onClose={onCloseModal}>
        <ModalContent
          sx={(theme: Theme) => ({
            position: "relative",
            maxWidth: 640,
            overflow: "hidden",
            [theme.breakpoints.down("md")]: {
              maxHeight: "unset",
              margin: "unset",
              borderRadius: 1,
            },
            display: "flex",
            flexDirection: "column",
            gap: 16,
          })}
        >
          <ModalCloseButton
            aria-label={t("Close")}
            sx={{
              position: "absolute",
              top: 0,
              right: 0,
              height: 48,
              width: 48,
            }}
            size={"large"}
            onClick={onCloseModal}
          />
          <Box
            sx={{
              maxHeight: 860,
              flexGrow: 1,
              marginTop: 4,
              paddingRight: 24,
              marginRight: -24,
              overflowY: "auto",
              "@media (max-height: 860)": {
                maxHeight: "calc(100vh - 64px)",
              },
            }}
          >
            {children}
          </Box>
        </ModalContent>
      </Modal>
    </>
  );
}
